<div layout-vertical gap-small-xx padding-bottom-small-xx>
  <div class="row">
    <rt-heading>
      {{ 'app.candidate.placements.disqualified_tooltip.title' | translate }}
    </rt-heading>
  </div>
  <div class="row">
    <div text-weight-semi-bold>
      {{ 'app.candidate.placements.disqualified_tooltip.reason' | translate }}
    </div>
    <div layout layout-align-items-start>
      <rt-icon
        name="block"
        colorToken="colorIconCriticalDefault"
        size="small-x"
        margin-right-small-xx
        margin-top-small-xxx
      ></rt-icon>
      <span text-critical>
        {{ placement().disqualifyReason }}
      </span>
    </div>
  </div>
  <div class="row">
    <div text-weight-semi-bold>
      {{ 'app.candidate.placements.disqualified_tooltip.date' | translate }}
    </div>
    <span>
      {{ placement().disqualifiedAt | amDateFormat: 'll' }}&nbsp;(<rt-date
        [time]="placement().disqualifiedAt!"
        [tinyWithSuffix]="true"
      ></rt-date
      >)
    </span>
  </div>
  <div class="row">
    <div text-weight-semi-bold>
      {{ 'app.candidate.placements.disqualified_tooltip.reached_stage' | translate }}
    </div>
    {{ placement().stage.name }}
  </div>
  <div class="row">
    <div text-weight-semi-bold>
      {{ 'app.candidate.placements.disqualified_tooltip.disqualified_by' | translate }}
    </div>
    <div layout layout-align-items-center>
      @let disqualifiedByVal = disqualifiedBy();
      @if (disqualifiedByVal) {
        @if (disqualifiedByVal !== 'system') {
          <rt-avatar
            [type]="$any(disqualifiedByVal)!.hasAvatar ? 'image' : 'initials'"
            [initials]="$any(disqualifiedByVal)!.initials"
            [size]="'small-x'"
            [shape]="'oval'"
            [imageSrc]="$any(disqualifiedByVal)!.photoThumbUrl"
            context="admin"
            margin-right-small-xx
          ></rt-avatar
          >{{ disqualifiedByName() }}
        } @else {
          {{ disqualifiedByName() }}
        }
      } @else {
        —
      }
    </div>
  </div>
</div>
